<footer class="footer">
  <div class="footer__copyright">
    <span>Ops IQ v{{ version }}</span>
    <span class="footer__separator">|</span>
    <span>&copy; {{ currentYear }} Chevron Corporation. All rights reserved.</span>
  </div>
</footer>
